import Laptop from "./components/laptop";
import Table from "./components/table"
import React from "react";
import {Link} from "react-router-dom";
import COPYRIGHT from "./config/copyright";
import './App.css';

const App = () => {
    return <Table>
        <div style={styles.links}>
            <Link style={styles.link} to={'index.html'}>Simplified version</Link>
            <Link style={styles.link} to={'feedback'}>Feedback</Link>
        </div>
        <Laptop />
        <div style={styles.copyright}>
            {COPYRIGHT}
        </div>
    </Table>
}


const styles = {
    links: {
        position: "absolute",
        zIndex: "10000",
        display: "flex",
    },
    link: {
        color: "black",
        background: "white",
        padding: "10px 20px",
        borderRadius: "10px",
        margin: "10px",
        opacity: "0.5",
    },
    copyright: {
        position: "absolute",
        bottom: "0",
        width: "100%",
        padding: "8px 0",
        textAlign: "center",
        fontSize: "12px",
        color: "rgba(255, 255, 255, 0.85)",
        textShadow: "0 1px 3px rgba(0, 0, 0, 0.8)",
        zIndex: "10000",
        pointerEvents: "none",
    }
}

export default App;
